export const CHECK_RENEWABILITY = "CHECK_RENEWABILITY";
export const CHECK_RENEWABILITY_SUCCESS = "CHECK_RENEWABILITY_SUCCESS";
export const CHECK_RENEWABILITY_FAILURE = "CHECK_RENEWABILITY_FAILURE";

export const RENEWAL_PAY_NOW = "RENEWAL_PAY_NOW";
export const RENEWAL_PAY_NOW_SUCCESS = "RENEWAL_PAY_NOW_SUCCESS";
export const RENEWAL_PAY_NOW_FAILURE = "RENEWAL_PAY_NOW_FAILURE";

export const GET_STATUS_MESSAGE = "GET_STATUS_MESSAGE";
export const GET_STATUS_MESSAGE_SUCCESS = "GET_STATUS_MESSAGE_SUCCESS";
export const GET_STATUS_MESSAGE_FAILURE = "GET_STATUS_MESSAGE_FAILURE";

export const RENEWAL_TIQ_HOME = "RENEWAL_TIQ_HOME";
export const RENEWAL_TIQ_HOME_SUCCESS = "RENEWAL_TIQ_HOME_SUCCESS";
export const RENEWAL_TIQ_HOME_FAILURE = "RENEWAL_TIQ_HOME_FAILURE";

export const checkRenewability = (submitData) => ({
  type: "CHECK_RENEWABILITY",
  submitData,
});

export const checkRenewabilitySuccess = (data) => ({
  type: "CHECK_RENEWABILITY_SUCCESS",
  data,
});

export const checkRenewabilityFailure = (message) => ({
  type: "CHECK_RENEWABILITY_FAILURE",
  message,
});

export const renewalPayNow = (premium, orderNo, nric, policyNo, isRecurring) => ({
  type: "RENEWAL_PAY_NOW",
  premium, orderNo, nric, policyNo, isRecurring,
});

export const renewalPayNowSuccess = (data) => ({
  type: "RENEWAL_PAY_NOW_SUCCESS",
  data,
});

export const renewalPayNowFailure = (message) => ({
  type: "RENEWAL_PAY_NOW_FAILURE",
  message,
});

export const getStatusMessage = (orderNo) => ({
  type: "GET_STATUS_MESSAGE",
  orderNo,
});

export const getStatusMessageSuccess = (data) => ({
  type: "GET_STATUS_MESSAGE_SUCCESS",
  data,
});

export const getStatusMessageFailure = (message) => ({
  type: "GET_STATUS_MESSAGE_FAILURE",
  message,
});

export const renewalTiqHome = (submitData) => ({
  type: "RENEWAL_TIQ_HOME",
  submitData,
});

export const renewalTiqHomeSuccess = (data) => ({
  type: "RENEWAL_TIQ_HOME_SUCCESS",
  data,
});

export const renewalTiqHomeFailure = (message) => ({
  type: "RENEWAL_TIQ_HOME_FAILURE",
  message,
});
